import { useSelector } from 'react-redux';

import { dateFormatNoTimeZone } from 'common/helpers/dateHelper';
import { imageFile } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

const Item = (props) => {
  const { item } = props;

  const settings = useSelector((state) => state.setting);
  const product = useSelector((state) => state.product.data?.[item.productId]);

  let shipDate;
  if (product) {
    const { metaData } = product;
    if (metaData && metaData['club-release-date']) {
      shipDate = dateFormatNoTimeZone(
        metaData['club-release-date'],
        'darioush'
      );
    }
  }

  return (
    <li className="receipt-product">
      <span className="receipt-product-image">
        <img src={imageFile(item.image, 'small')} alt={item.productTitle} />
      </span>
      <span className="receipt-product-description">
        {item.quantity} of {item.productTitle}
      </span>
      <span className="receipt-product-price">
        {currencyFormat(item.price, settings)}
      </span>
      {shipDate && (
        <span className="receipt-product-shipping">
          Next Release {shipDate}
        </span>
      )}
    </li>
  );
};

export default Item;
